import { useContext } from 'react'
import TranslationContext from './TranslationContext'

export function useTranslation() {
  return useContext(TranslationContext)
}
